<template>
    <b-modal id="order-preview-modal" size="xl">
        <template #modal-title>
            Essenstatistik
        </template>
        <div class="d-block">
            <h6>{{ currentDate }}</h6>
        </div>

        <b-form-group v-if="options"
                      label-cols-lg="1" content-cols-lg="11"
                      label="Einrichtung:"
                      v-slot="{ ariaDescribedby }"
        >
            <b-form-radio-group
                id="btn-radios-2"
                v-model="selectedLocation"
                :options="options"
                :aria-describedby="ariaDescribedby"
                class="location-filter"
                button-variant="outline-success"
                @input="handleFilter"
                name="selected-location"
                buttons
            ></b-form-radio-group>
        </b-form-group>

        <b-overlay :show="show" rounded="sm">
            <div v-if="orders.length">
                <b-table
                    striped
                    hover
                    show-empty
                    small
                    stacked="md"
                    :items="orders"
                    :fields="fields"
                    class="statistic"
                >
                    <template v-slot:cell(name)="row">
                        <div style="font-size: 18px;">
                            <span class="font-weight-bold">{{ row.item.menuCategoryName }}</span>
                        </div>
                    </template>
                    <template v-slot:cell(preordered)="row">
                        <div>{{ row.item.preOrders }}</div>
                    </template>
                    <template v-slot:cell(posordered)="row">
                        <div>{{ row.item.posOrders }}</div>
                    </template>
                    <template v-slot:cell(spontaneous)="row">
                        <div>{{ row.item.vouchers }}</div>
                    </template>
                    <template v-slot:cell(total)="row">
                        <div class="total">
                            {{
                                parseInt(row.item.preOrders) + parseInt(row.item.posOrders) + parseInt(row.item.vouchers)
                            }}
                        </div>
                    </template>
                </b-table>
            </div>
            <ul v-else class="mb-0 pl-3 pr-3">
                <li class="d-flex justify-content-between pt-1 pb-1">
                    <span>Keine Essenstatistik für {{ currentDate }}</span>
                </li>
            </ul>
        </b-overlay>
        <template #modal-footer>
            <div class="d-flex justify-content-between w-100 day-links">
                <label for="datePicker" class="float-left">Datum</label>
            </div>
            <div class="d-flex justify-content-between w-100 day-links">
                <b-form-datepicker
                    id="datePicker"
                    v-model="datePicker"
                    @input="getOrders(datePicker)"
                    :locale="'de'"
                    :start-weekday="1"
                    :show-decade-nav="false"
                    :hide-header="false"
                    class="mb-2"
                ></b-form-datepicker>
            </div>
        </template>
    </b-modal>
</template>

<script>
import {getOrdersStatistic}               from "@/api/food-order";
import {mapGetters, mapActions, mapState} from "vuex";

export default {
    name: 'OrderPreviewModal',
    data() {
        return {
            show:             false,
            orders:           [],
            selectedLocation: false,
            filters:          [],
            date:             '',
            datePicker:       new Date(),
            fields:           [
                {key: 'name', label: ''},
                {key: 'preordered', label: 'Vorbestellt'},
                {key: 'posordered', label: 'Nachbucher'},
                {key: 'spontaneous', label: 'Bar verkauft'},
                {key: 'total', label: 'Gesamt'},
            ],
        }
    },
    computed: {
        ...mapState(['auth']),
        currentDate() {
            return this.formatDate(this.createDate());
        },
        options() {
            const self   = this;
            self.filters = [];

            for (let location of self.auth.userLocations) {
                self.filters.push({
                    'text':  location.name,
                    'value': location.id,
                })
            }

            return self.filters;
        },
    },
    mounted() {
        this.$root.$on('bv::modal::show', () => {
            clearTimeout(this.getInternalId());
            let locations         = this.auth.userLocations;
            this.selectedLocation = locations[0].id;

            this.getOrders(this.currentDate)
        });
        this.$root.$on('bv::modal::hide', () => {
            this.datePicker = new Date();
            let timerId     = setInterval(this.getAutocompleteFocus(), 1000);
            this.setIntervalId(timerId);
            this.date = '';

            //Firefox browser autofocus fix
            setTimeout(() => {
                if (document.querySelector('.autocomplete-input')) {
                    document.querySelector('.autocomplete-input').focus();
                }
            }, 100);
        });
    },
    methods: {
        ...mapGetters(['getInternalId', 'getAutocompleteFocus']),
        ...mapActions(['setIntervalId']),
        async handleFilter() {
            const self = this;

            await self.getOrders(self.currentDate);
        },
        createDate() {
            return this.date ? new Date(this.date) : new Date();
        },
        formatDate(day) {
            const dd   = String(day.getDate()).padStart(2, '0');
            const mm   = String(day.getMonth() + 1).padStart(2, '0');
            const yyyy = day.getFullYear();

            return dd + '.' + mm + '.' + yyyy;
        },
        async getOrders(date) {
            const self = this;

            this.show    = true;
            const params = {
                date:        date,
                locationIds: [self.selectedLocation],
            };

            await getOrdersStatistic(params)
                .then((res) => {
                    self.date   = res.data.date;
                    self.orders = Object.values(res.data.orders);
                    self.show   = false;
                });
        },
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/custom_theme";

.day-links span:hover {
    cursor: pointer;
}

> > > .modal-dialog {
    margin-top: 3.75rem;
}

> > > .modal-dialog .btn-outline-success {
    color: $accent-color;
    border-color: $accent-color;
    margin-right: 10px !important;
    border-radius: 20px !important;
    padding: 6px !important;
}

> > > .location-filter {
    display: block !important;
}

> > > .location-filter label {
    margin-bottom: 4px !important;
}
</style>
